import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest, filter, take } from 'rxjs';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-callback',
    template: `
    <ion-content class="ion-text-center">
      @if (!errorMessage) {
        <div class="callback-center">
          <ion-spinner name="crescent" color="primary"></ion-spinner>
          <p>Anmeldung wird abgeschlossen …</p>
        </div>
      }
      @if (errorMessage) {
        <div class="callback-center">
          <ion-icon name="alert-circle-outline" color="danger" style="font-size:3rem"></ion-icon>
          <p style="color:var(--ion-color-danger)">{{ errorMessage }}</p>
          <ion-button fill="outline" (click)="retryLogin()">Erneut versuchen</ion-button>
        </div>
      }
    </ion-content>
    `,
    styles: [`.callback-center { display:flex; flex-direction:column; align-items:center; justify-content:center; height:100%; gap:1rem; padding:2rem; text-align:center; }`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule]
})
export class CallbackPage implements OnInit {
  errorMessage: string | null = null;

  constructor(
    private auth0: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.auth0.error$.pipe(take(1)).subscribe(err => {
      if (err) {
        this.errorMessage = err.message ?? 'Anmeldung fehlgeschlagen.';
        this.cdr.markForCheck();
      }
    });

    combineLatest([this.auth0.isLoading$, this.auth0.isAuthenticated$]).pipe(
      filter(([loading]) => !loading),
      take(1),
    ).subscribe(([, isAuthenticated]) => {
      this.router.navigate([isAuthenticated ? '/tokens' : '/unauthorized']);
    });
  }

  retryLogin(): void {
    this.auth0.logout({ logoutParams: { returnTo: window.location.origin } });
  }
}
